import React, { useContext, useState } from "react";
import { createPortal } from "react-dom";
import { FiX } from "react-icons/fi";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import MobileNav from "./MobileNav";
import NavBadge from "./NavBadge";
import VerifyEmailBanner from "./VerifyEmailBanner";
import { NAV_ITEMS, ADMIN_NAV_ITEMS } from "./navItems";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { NotificationContext } from "../../context/NotificationContext";
import logo from "../../Assets/Images/EMPACT LOGO.png";

function DrawerNavItem({ to, label, icon: Icon, notifKey, categoryCounts, onClose }) {
  return (
    <NavLink
      to={to}
      onClick={onClose}
      className={({ isActive }) =>
        `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium ${
          isActive ? "bg-primary-50 text-primary-700" : "text-slate-600 hover:bg-slate-50"
        }`
      }
    >
      <Icon className="h-[18px] w-[18px]" />
      {label}
      {notifKey && <NavBadge count={categoryCounts[notifKey]} />}
    </NavLink>
  );
}

function MobileDrawer({ open, onClose }) {
  const { isAdmin } = useContext(AuthContext);
  const { categoryCounts } = useContext(NotificationContext);
  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-50 lg:hidden">
      <div className="absolute inset-0 bg-slate-900/50" onClick={onClose} />
      <div className="absolute inset-y-0 left-0 w-72 animate-fade-in bg-white shadow-popover">
        <div className="flex h-16 items-center justify-between px-5">
          <img src={logo} alt="Empact Alumni" className="h-8 w-auto" />
          <button onClick={onClose} className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100">
            <FiX className="h-5 w-5" />
          </button>
        </div>
        <nav className="space-y-0.5 px-3 py-2">
          {NAV_ITEMS.map((item) => (
            <DrawerNavItem key={item.to} {...item} categoryCounts={categoryCounts} onClose={onClose} />
          ))}
          {isAdmin && (
            <>
              <div className="my-3 border-t border-slate-100 pt-3">
                <p className="px-3 pb-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-400">
                  Admin
                </p>
              </div>
              {ADMIN_NAV_ITEMS.map((item) => (
                <DrawerNavItem key={item.to} {...item} categoryCounts={categoryCounts} onClose={onClose} />
              ))}
            </>
          )}
        </nav>
      </div>
    </div>,
    document.body
  );
}

export default function AppShell({ title, subtitle, children, wide = false }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <div className="lg:pl-64">
        <Topbar title={title} subtitle={subtitle} onMenuClick={() => setDrawerOpen(true)} />
        <VerifyEmailBanner />
        <main className={`mx-auto w-full px-4 pb-24 pt-6 sm:px-6 lg:pb-10 ${wide ? "max-w-6xl" : "max-w-4xl"}`}>
          {children}
        </main>
      </div>
      <MobileNav />
    </div>
  );
}
